/**
 * Structured logging with Pino for better debugging and monitoring
 * 
 * Benefits:
 * - Structured JSON logging
 * - Environment-aware log levels
 * - Module-specific loggers
 * - Pretty printing in development
 * - Production-ready logging
 */
import pino from 'pino';

const logger = pino({
  level: import.meta.env.DEV ? 'debug' : 'info',
  transport: import.meta.env.DEV ? {
    target: 'pino-pretty',
    options: {
      colorize: true,
      translateTime: 'HH:MM:ss',
      ignore: 'pid,hostname',
    },
  } : undefined,
});

// Create namespaced loggers
export const authLogger = logger.child({ module: 'auth' });
export const apiLogger = logger.child({ module: 'api' });
export const routerLogger = logger.child({ module: 'router' });

// Default logger
export default logger;
